
import { Swiper, Navigation } from "swiper";
import HotArticleCardAdult from './HotArticleCardAdult.vue';
import HotArticleCardAdultAD from "./HotArticleCardAdultAd.vue";
import HotArticleCardAdultMedia from "./HotArticleCardAdultMedia.vue";
export default {
    name: "Adult-theme-article-container",
    components: {
        HotArticleCardAdult,
        HotArticleCardAdultAD,
        HotArticleCardAdultMedia,
    },
    props: {
        article_data_full: Array,
        pa_page_name: String,
        theme_title: String,
        custom_class: String,
        custom_e_label: String,
        custom_e_action: String
    },
    data() {
        return {
            pa_count: 1,
            swiper: '',
            observe_class: '.' + this.custom_class
        }
    },
    methods: {
        activeSwiper() {
            Swiper.use([Navigation]);
            this.swiper = new Swiper(this.observe_class, {
                direction: "horizontal",
                breakpoints: {
                    769: {
                        slidesPerGroup: 1,
                        slidesPerView: 3,
                        spaceBetween: 12
                    }
                },
                slidesPerView: 1.4,
                slidesPerGroup: 1,
                spaceBetween: 8,
                observer: true,
                modules: [Navigation],
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                }
            });
        }
    },
    computed: {
        article_model_id_index() {
            return this.$store.state.article.model_id_index;
        },
    },
    mounted() {
        this.activeSwiper();
    },
    updated() {
        this.activeSwiper();
    }
}
